import React, { useEffect, useRef, useState } from "react";
import PageHeading from "../common/PageHeading";
import {
	Facebook,
	Info,
	Instagram,
	Numpad,
	PeopleIcon,
	Phone,
	Share,
	Star,
	User,
	User_Second,
	Whatsapp,
	Youtube,
} from "../../utils/SvgComponents";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import CustomButton from "../common/button/Button";
import CustomCard from "../common/card/Card";
const BrandAboutUs = () => {
	const nextBtn = useRef();
	const prevBtn = useRef();
	const [isSticky, setIsSticky] = useState(false);
	let animationFrameId = null;
	useEffect(() => {
		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);
	const changePage = (page) => {
		if (page === 0) {
			if (index !== page) {
				prevBtn.current.click();
			}
		} else {
			if (index !== page) {
				nextBtn.current.click();
			}
		}
	};

	const [index, setIndex] = useState(0);

	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white', height: '100vh' }}>
			<div className="hidden sm:block h-screen overflow-hidden">
				<div className="grid grid-cols-12">
					<div
						className="col-span-5 bg-cover bg-center h-full text-center"
						style={{ backgroundColor: "gray" }}
					>
						<div className="h-full bg-black/50 flex flex-col justify-between items-center">
							<div className="h-full flex flex-col justify-center items-center">
								<div className="rounded-full overflow-hidden grid place-items-center pointer-events-none">
									{/* <img
										
										className="w-1/2 aspect-square"
										alt=""
									/> */}
								</div>
								<div className="text-white capitalize text-[37px] font-medium py-[15px] tracking-[1.2px]">
									Branding Name
								</div>
								<div className="text-white text-[20px] leading-[35px]">
									A Complete Creative Solutions <br />
									for your Wedding Needs
								</div>
								{true && (
									<div className="text-white text-[25px] flex flex-col items-center pt-[15px] gap-3">
										<div className="flex items-center font-medium gap-2 common-font ">
											<User width="25" fill="white" />{" "}
											Rahul Sharma
										</div>
										<div className="flex items-center font-medium gap-2">
											<Phone width="25" fill="white" />{" "}
											9414243998
										</div>
									</div>
								)}
								{false && (
									<div className="mt-[20px] rounded-2xl border-[2.5px] border-white bg-black/65 overflow-hidden">
										<CustomButton clicked={() => { }}>
											<div className="py-3 px-6 uppercase text-[18px]">
												Book Your invite
											</div>
										</CustomButton>
									</div>
								)}
							</div>
							<div className="flex flex-col justify-center items-center gap-3 pb-[30px]">
								<div className="text-white capitalize text-[20px]">
									Follow Us On Social Media
								</div>
								<div className="flex justify-center items-center gap-[23px] p-3">
									<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
										<CustomButton clicked={() => { }}>
											<div className="p-2">
												<Instagram
													width="35"
													fill="white"
												/>
											</div>
										</CustomButton>
									</div>
									<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
										<CustomButton clicked={() => { }}>
											<div className="p-2">
												<Facebook
													width="35"
													fill="white"
												/>
											</div>
										</CustomButton>
									</div>
									<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
										<CustomButton clicked={() => { }}>
											<div className="p-2">
												<Youtube
													width="35"
													fill="white"
												/>
											</div>
										</CustomButton>
									</div>
									<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
										<CustomButton clicked={() => { }}>
											<div className="p-2">
												<Whatsapp
													width="35"
													fill="white"
												/>
											</div>
										</CustomButton>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-span-7">
						<div className="h-screen overflow-x-auto scroll-bar">
							<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'white', textAlign: 'center' }}>
								<PageHeading title={"Our Services"} />
							</div>
							<div className="grid grid-cols-2 mt-[16px] px-[15px]">
								{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
									<div
										key={item}
										className=" "
									>
										<div
											className="m-[16px] p-[1rem] rounded-2xl"
											style={{
												boxShadow:
													"0px 0px 5px 2px rgba(0,0,0,0.2)",
											}}
										>
											<div className="flex justify-start items-center gap-[0.75rem] pb-2">
												<div className="bg-black p-2 rounded-full">
													<Youtube
														width="35"
														fill="white"
													/>
												</div>
												<div className="text-lg font-semibold black-color tracking-[0.2px] common-font">
													Wedding Invitations
												</div>
											</div>
											<div className="text-left common-font black-color tracking-[0.1px]">
												Our team of talented
												designers can help you
												create beautiful, custom
												wedding invitations that
												perfectly capture your style
												and personality.
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="block sm:hidden h-svh overflow-hidden bg-center bg-cover"
				style={{ backgroundColor: "gray" }}
			>
				<div className="h-full flex flex-col bg-black/40">
					<Swiper
						// effect={"coverflow"}
						grabCursor={true}
						slideToClickedSlide={true}
						// loop={true}
						height="100%"
						// centeredSlides={true}
						slidesPerView={1}
						onRealIndexChange={(e) => setIndex(e.realIndex)}
						// slidesPerGroup={1}
						// slidesPerGroupAuto={true}
						// loopAddBlankSlides={true}
						freeMode={true}
						// updateOnWindowResize={true}
						autoHeight={true}
						keyboard={true}
						// spaceBetween={"10px"}
						// coverflowEffect={{
						//     rotate: 0,
						//     stretch: 0,
						//     depth: 0,
						//     modifier: 1,
						//     scale: 0.75,
						//     slideShadows: false,
						// }}
						// onUpdate={responseData}
						navigation={{
							enabled: true,
							nextEl: "#custom-next-button",
							prevEl: "#custom-prev-button",
						}}
						// pagination={{
						//     enabled: true,
						//     clickable: true,
						//     el: "#custom-mobile-pagination",
						//     type: "bullets",
						// }}
						modules={[
							// EffectCoverflow,
							// Pagination,
							Navigation,
						]}
						className="mySwiper about-us-mobile-slider flex-auto p-0"
						// initialSlide={2}
						speed={500}
					>
						<SwiperSlide>
							<div className="h-full px-10 overflow-y-auto text-center flex flex-col justify-between items-center">
								<div className="flex flex-col justify-center items-center flex-auto">
									<div className="rounded-full">
										{/* <img
											
											width={50}
											className=""
											alt=""
										/> */}
									</div>
									<div className="flex flex-col justify-center items-center gap-3">
										<div className="text-white capitalize text-[33px] font-medium pt-[15px]">
											Branding Name
										</div>
										<div className="text-white text-[18px] leading-7">
											A Complete Creative Solutions <br />
											for your Wedding Needs
										</div>
										<div className="text-white flex flex-col items-center gap-[10px] text-[20px] font-medium">
											<div className="flex items-center gap-2">
												<User width="25" fill="white" />{" "}
												Rahul Sharma
											</div>
											<div className="flex items-center gap-2">
												<Phone
													width="25"
													fill="white"
												/>{" "}
												9414243998
											</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col justify-center items-center gap-[15px] pt-[30px]">
									<div className="text-white capitalize text-[18px]">
										Follow Us On Social Media
									</div>
									<div className="flex justify-center items-center gap-[1.25rem] pb-[25px]">
										<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
											<CustomButton clicked={() => { }}>
												<div className="p-[7px]">
													<Instagram
														width="29"
														fill="white"
													/>
												</div>
											</CustomButton>
										</div>
										<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
											<CustomButton clicked={() => { }}>
												<div className="p-[7px]">
													<Facebook
														width="29"
														fill="white"
													/>
												</div>
											</CustomButton>
										</div>
										<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
											<CustomButton clicked={() => { }}>
												<div className="p-[7px]">
													<Youtube
														width="29"
														fill="white"
													/>
												</div>
											</CustomButton>
										</div>
										<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
											<CustomButton clicked={() => { }}>
												<div className="p-[7px]">
													<Whatsapp
														width="29"
														fill="white"
													/>
												</div>
											</CustomButton>
										</div>
									</div>
								</div>
							</div>
						</SwiperSlide>
						<SwiperSlide>
							<div className="p-[15px] relative overflow-y-auto h-full">
								<div className="flex flex-col gap-[15px]">
									{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
										(item) => (
											<CustomCard
												key={item}
												clicked={() => { }}
											>
												<div
													className="rounded-lg p-[17px] bg-black/50 text-white"
												// style={{
												//     boxShadow:
												//         "0px 0px 5px 2px rgba(0,0,0,0.2)",
												// }}
												>
													<div className="flex justify-start items-center gap-3 pb-2">
														<div className="bg-white w-[40px] h-[40px] rounded-full">
															{/* <Youtube
                                                                                                            width="24"
                                                                                                            // fill="white"
                                                                                                        /> */}
														</div>
														<div className="text-lg font-[550]">
															Wedding Invitations
														</div>
													</div>
													<div className="text-[15px]">
														Our team of talented
														designers can help you
														create beautiful, custom
														wedding invitations that
														perfectly capture your
														style and personality.
													</div>
												</div>
											</CustomCard>
										)
									)}
								</div>
							</div>
						</SwiperSlide>
					</Swiper>
					<div className="bg-black/65 flex">
						<CustomButton clicked={() => { }} flex="1">
							<div
								className={`relative flex-1 py-[15px] text-white flex flex-col justify-center items-center gap-2`}
								onClick={() => changePage(0)}
							>
								<div
									className={`absolute top-0 right-0 h-[2px] bg-white transition-all duration-[3s] rotate-180 ${index === 0 ? "left-0" : "left-[unset]"
										}`}
									style={{ animationDirection: "reverse" }}
								></div>
								<div className="flex flex-col justify-center items-center gap-[7.5px]">
									<div>
										<Info fill="white" width="30" />
									</div>
									<div className="normal-case font-medium text-[16.5px]">
										About Us
									</div>
								</div>
							</div>
						</CustomButton>
						<CustomButton clicked={() => { }} flex="1">
							<div
								className="relative flex-1 py-[15px] text-white flex flex-col justify-center items-center gap-2"
								onClick={() => changePage(1)}
							>
								<div
									className={`absolute top-0 left-0 right-0 h-[2px] bg-white transition-[width] duration-[3s] ${index === 1 ? "w-full" : "w-0"
										}`}
								></div>
								<div className="flex flex-col justify-center items-center gap-[7.5px]">
									<div>
										<User_Second fill="white" width="30" />
									</div>
									<div className="normal-case font-medium text-[16.5px]">
										Our Services
									</div>
								</div>
							</div>
						</CustomButton>
					</div>
				</div>
			</div>
			<div id="custom-next-button" ref={nextBtn}></div>
			<div id="custom-prev-button" ref={prevBtn}></div>
		</div>
	);
};

export default BrandAboutUs;
